import { IAppState } from 'src/store/types';

export const getUserData = (state: IAppState) => state.requests.user.data;
export const getUserLoading = (state: IAppState) => state.requests.user.isLoading;
